<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
            <a href="/">
                <img src="./assets/img/cxgdlogo.png" alt />
            </a>
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/" >首页</el-menu-item>
          <el-menu-item index="/product" >产品中心</el-menu-item>
          <el-menu-item index="/solution" >解决方案</el-menu-item>
          <el-menu-item index="/case">案例展示</el-menu-item>
          <el-menu-item index="/service">技术支持</el-menu-item>
          <el-menu-item index="/about" >关于长芯</el-menu-item>
          <el-menu-item index="/contact">联系我们</el-menu-item>
        </el-menu>
      </el-header>
        <el-main>
            <router-view />
        </el-main>
        <div class="footer" v-show="true">
            <div class="background">
                <div class="footer-content">
                    <ul class="content-nav">
                        <li>
                            <router-link class="p-text" :to="{ name: 'product'}">
                                <p>产品中心</p>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'productDetailsBH'}">
                                <span>冰火系列</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'productDetailsXD'}">
                                <span>炫碟系列</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'productDetailsFP'}">
                                <span>飞瀑系列</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'productDetailsZM'}">
                                <span>种苗系列</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'productDetailsCS'}">
                                <span>城市阳台系列</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'productDetailsJG'}">
                                <span>菌菇工厂系列</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link class="p-text" :to="{ name: 'solution'}">
                                <p>解决方案</p>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'solutionDetailsJGYM'}">
                                <span>激光育苗</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'solutionDetailsGSZZ'}">
                                <span>果树种植</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'solutionDetailsJJZW'}">
                                <span>经济作物</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'solutionDetailsNGHB'}">
                                <span>农光互补</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'solutionDetailsDCZZ'}">
                                <span>多层种植</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link class="p-text" :to="{ name: 'case'}">
                                <p>案例展示</p>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'caseDetailsZLS'}">
                                <span>主粮食案例</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'caseDetailsZCY'}">
                                <span>中草药案例</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'caseDetailsSC'}">
                                <span>蔬菜案例</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'caseDetailsSG'}">
                                <span>水果案例</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'caseDetailsHH'}">
                                <span>花卉案例</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'caseDetailsNGHB'}">
                                <span>农光互补案例</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link class="p-text" :to="{ name: 'service'}">
                                <p>技术支持</p>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'info'}">
                                <span>服务优势</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'faq'}">
                                <span>常见问题</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'down'}">
                                <span>下载中心</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link class="p-text" :to="{ name: 'about'}">
                                <p>关于长芯</p>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'know'}">
                                <span>认识长芯</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'honor'}">
                                <span>荣誉资质</span>
                            </router-link>
                            <router-link class="span-text" :to="{ name: 'patent'}">
                                <span>专利证书</span>
                            </router-link>
                        </li>
<!--                        <li>-->
<!--                            <router-link class="p-text" :to="{ name: 'contact'}">-->
<!--                                <p>联系我们</p>-->
<!--                            </router-link>-->
<!--                            <span>联系方式</span>-->
<!--                            <span>成为合作伙伴</span>-->
<!--                        </li>-->
                    </ul>
                    <ul class="content-nav-1">
                        <li>
                            <p>CONTACT US</p>
                            <span>公司总部地址：杭州市上城区中国数谷·未来数智港1层1-B04</span>
                            <span>联系电话：153 3655 1782</span>
                            <span>市场邮箱：market@cxoptotech.com</span>
                            <span>技术服务邮箱：tech@cxoptotech.com</span>
                        </li>
                    </ul>
                </div>
                <div class="copyright">
                <span>
                    Copyright 2023 浙江长芯光电科技有限公司版权所有
                    <a class="beian"
                       href="https://beian.miit.gov.cn"
                       target="_blank"
                    >
                        浙ICP备2023017319号
                    </a>
                    <a class="beian"
                       href="https://beian.miit.gov.cn"
                       target="_blank"
                    >
                        浙ICP备2023017319号-1
                    </a>
                </span>
                </div>
            </div>

        </div>

    </el-container>
  </div>
</template>

<script>

export default {
  data() {
    return {
      router: true,
      defaultActive: "",
      isShow: true
    };
  },
  mounted() {
      this.defaultActive = sessionStorage.getItem('keyPath') || '/';
  },
  methods: {
      handleSelect(key) {
          this.isShow = this.defaultActive !== key;
          window.console.log(this.isShow);
      },
  },
    watch: {
      $route(to, from) {
          this.defaultActive = sessionStorage.getItem('keyPath') || '/';
      }
    }

};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  height: 80px !important; /* 设置所需的高度值 */
  /*width: 1240px;*/
  /*margin: 0 auto; //将元素水平居中，上下边距为0*/
  /*background: rgba(1, 89, 147, 1);*/
  .logo {
    margin-top: 20px !important; /* 设置所需的上侧边距值 */
    margin-left: 5px !important; /* 设置所需的上侧边距值 */
    /*width: 300px;*/
    img {
      height: 48px !important;
      /*width: 100%;*/
      line-height: 55px !important;
    }
  }
}
.el-menu {
    height: 60px !important; /* 设置所需的高度值 */
    margin-right: 150px !important; /* 设置所需的右侧边距值 */
}
.el-menu-item {
    font-size: 17px !important;
    height: 60px !important; /* 设置所需的高度值 */
    margin-right: 20px !important; /* 设置所需的右侧边距值 */
    margin-top: 20px !important; /* 设置所需的上侧边距值 */
    font-weight: bold; /* 设置字体粗细 */
    font-family: "微软雅黑";
}
.el-menu.el-menu--horizontal {
    border-bottom: solid 0px #ffffff !important;
    .el-menu-item.is-active {
        /*border-bottom: 2px solid #ff4062;*/
    }
}
.body {
    /*width: 100%;*/
}
.el-main {
    /*width: 100% !important;*/
    width: 1519px;
    margin: 0 auto;
    padding: 0 !important;

}
.p-text {
    text-decoration: none;
}
.span-text {
    text-decoration: none;
    padding: 5px 0;
}
.footer {
  width: 100%;
  height: 300px;
  overflow: hidden;
  background-color: #fff;
  .background {
      width: 100%;
      background-color: rgb(1, 89, 147);
      margin: 0 auto;
  }
  &-content {
    width: 1240px;
    height: 240px;
    margin: 0 auto;
    /*padding-top: 20px;*/
    display: flex;
    justify-content: space-between;
    .content-nav {
      width: 1240px;
      display: flex;
      justify-content: space-around;
      li {
        width: 16%;
        /*margin: 10px;*/
        display: flex;
        flex-direction: column;
        padding: 10px 0;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 15px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          font-size: 12px;
          color: #a4bac9;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }

    .content-nav-1 {
        width: 40%;
        li {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 10px 0;
            //justify-content: center;
            align-items: flex-start;
            p {
                font-size: 24px;
                color: #a4bac9;
                padding: 10px 0;
            }
            span {
                font-size: 15px;
                color: #ffffff;
                font-weight: 100;
                padding: 2px 0;
            }
        }
    }
    /*img {*/
    /*  width: 170px;*/
    /*  height: 170px;*/
    /*  padding: 10px;*/
    /*}*/
  }
    .copyright {
        height: 60px;
        background: #034a7f;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        span {
            color: #d4edff;
        }
        .beian {
            text-decoration: none;
            color: #d4edff;
        }
    }
}
</style>
